import { InjectionToken } from "@angular/core";

export const API_URI = new InjectionToken<string>("API_URI");

export class ApiUri {
  login: Login;
  personnalInformation: PersonnalInformation;
  shareholder: Shareholder;
  microLoan: MicroLoan;
  interest: Interest;
  chat: Chat;
  notification: Notification;
  offerPeriod: OfferPeriod;
  interestPeriod: InterestPeriod;
  personalInfo: PersonalInfo;
  emission: Emission;
  interestPayment: InterestPayment;
  reminder: Reminder;
  enquiry: Enquiry;
  disclaimer: Disclaimer;
  setting: Setting;
}
export class Login {
  LOGIN: string;
  FORGET_PASSWORD: string;
  RESET_PASSWORD: string;
  CHANGE_PASSWORD: string;
}
export class PersonnalInformation {
  GET: string;
  UPDATE_PERSONAL: string;
  UPDATE_BANK: string;
}
export class Shareholder {
  GET: string;
  POST: string;
  REGISTER_ONE: string;
  REGISTER_BULK: string;
  DOWNLOAD_HOLDER_DATA: string;
}
export class MicroLoan {
  GET: string;
}
export class Interest {
  GET: string;
  GET_BALANCE: string;
}
export class Chat {
  GET: string;
  REPLY: string;
  MESSAGE: string;
  UPDATE_STATUS: string;
}
export class Notification {
  GET: string;
}
export class OfferPeriod {
  GET: string;
  POST: string;
  DOWNLOAD: string;
  DELETE: string;
}

export class InterestPeriod {
  GET: string;
  POST: string;
  DELETE: string;
}

export class PersonalInfo {
  GET: string;
  UPLOAD_FILE: string;
  DOWNLOAD: string;
  DELETE: string;
}

export class Emission {
  GET: string;
  UPLOAD_FILE: string;
  DOWNLOAD: string;
  DELETE: string;
}

export class InterestPayment {
  GET: string;
  UPLOAD_FILE: string;
  DOWNLOAD: string;
  DELETE: string;
}

export class Reminder {
  GET: string;
  POST: string;
  DELETE: string;
}

export class Enquiry {
  GET: string;
}

export class Disclaimer {
  GET: string;
  POST: string;
  DELETE: string;
  LATEST_DISCLAIMER: string;
}

export class Setting {
  GET: string;
  POST: string;
}

export function ApiUriFactory(): ApiUri {
  let api = new ApiUri();

  api.login = <Login>{
    LOGIN: "Auth/login",
    FORGET_PASSWORD: "Accounts/ResetPasswordToken",
    RESET_PASSWORD: "Accounts/ResetPassword",
    CHANGE_PASSWORD: "Accounts/ChangePassword",
  };

  api.personnalInformation = <PersonnalInformation>{
    GET: "Shareholders/PersonalInformation?SocialSecurityNumber=",
    UPDATE_PERSONAL: "Shareholders/PersonalInformation",
    UPDATE_BANK: "Shareholders/BankInformation",
  };

  api.shareholder = <Shareholder>{
    GET: "Admin/ListShareholder",
    POST: "ShareholderInformation/ShareholderInformation",
    REGISTER_ONE: "Accounts/ResisterUser",
    REGISTER_BULK: "Admin/BulkUserActiveInactive",
    DOWNLOAD_HOLDER_DATA: "Report/ReportShareholdersPaymentInterest",
  };

  api.microLoan = <MicroLoan>{
    GET: "Shareholders/LoanPortfolio?SocialSecurityNumber=",
  };

  api.interest = <Interest>{
    GET: "InterestPayment/InterestPayment?socialSecurityNumber=",
    GET_BALANCE: "InterestPayment/InterestPaymentBalance?",
  };

  api.chat = <Chat>{
    GET: "Enquiry/EnquiryChat?socialSecurityNumber=",
    REPLY: "Enquiry/UpdateEnquiryReply",
    MESSAGE: "Enquiry/Enquiry",
    UPDATE_STATUS: "Enquiry/UpdateEnquiryStatus",
  };

  api.notification = <Notification>{
    GET: "Enquiry/NotificationList",
  };

  api.offerPeriod = <OfferPeriod>{
    GET: "OfferPeriod/OfferPeriod",
    POST: "OfferPeriod/OfferPeriod",
    DOWNLOAD: "Report/ReportShareholders",
    DELETE: "OfferPeriod/OfferPeriod?id=",
  };

  api.interestPeriod = <InterestPeriod>{
    GET: "InterestPeriod/InterestPeriod",
    POST: "InterestPeriod/InterestPeriod",
    DELETE: "InterestPeriod/InterestPeriod?id=",
  };

  api.personalInfo = <PersonalInfo>{
    GET: "Shareholders/UploadReference?fileType=Personal",
    UPLOAD_FILE: "ImportExcel/ImportPersonalDataXml",
    DOWNLOAD: "SampleFile/SamplePersonalInformation",
    DELETE: "Shareholders/UploadReference?Id=",
  };

  api.emission = <Emission>{
    GET: "Shareholders/UploadReference?fileType=Emission",
    UPLOAD_FILE: "ImportExcel/ImportEmissionXml",
    DOWNLOAD: "SampleFile/SampleEmission",
    DELETE: "Shareholders/UploadReference?Id=",
  };

  api.interestPayment = <InterestPayment>{
    GET: "Shareholders/UploadReference?fileType=InterestPayment",
    UPLOAD_FILE: "ImportExcel/ImportInterestPaymentXml",
    DOWNLOAD: "SampleFile/SampleInterestPayment",
    DELETE: "Shareholders/UploadReference?Id=",
  };

  api.reminder = <Reminder>{
    GET: "Reminder/Reminder",
    POST: "Reminder/Reminder",
    DELETE: "Reminder/Reminder?id=",
  };

  api.enquiry = <Enquiry>{
    GET: "Enquiry/UnreadEnquiryChat",
  };

  api.disclaimer = <Disclaimer>{
    GET: "Disclaimer/Disclaimer",
    POST: "Disclaimer/Disclaimer",
    DELETE: "Disclaimer/Disclaimer?id=",
    LATEST_DISCLAIMER: "Disclaimer/LatestDisclaimer",
  };

  api.setting = <Setting>{
    GET: "Settings/Settings",
    POST: "Settings/Settings",
  };

  return api;
}
